// Translator notes: sound rules of prepositive adjectives (engine/src/passes/prepositive-final-m.ts,
// rules/peterson-grammar.ts HV_PREPOSITIVE_FINAL_M).
// Each id is an engine note (`notes.add(text, id, args)`); `args` names its arguments in the order the
// strings take them. Collected by translator/notes.ts (import.meta.glob): adding a note means adding it here.
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  prepositiveFinalM: {
    args: ['words'],
    fi: (a: string[]) =>
      `Petersonin mukaan substantiivin edellä olevan adjektiivin loppu-m muuttuu usein n:ksi, kun seuraava sana alkaa muulla konsonantilla kuin p, b, m, v tai f (${a[0]}). Wikin taulukoissa ja lauseissa m säilyy, joten n-muoto on vaihtoehtona.`,
    en: (a: string[]) =>
      `By Peterson, the final m of an adjective before its noun often becomes n when the next word begins with a consonant other than p, b, m, v or f (${a[0]}). The wiki’s tables and sentences keep the m, so the n form is given as an alternative.`,
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
